enum CidValidation {
  MOD10 = 'MOD10',
  MOD11 = 'MOD11',
  NUMERIC = 'NUMERIC',
  NONE = 'NONE',
}

export default CidValidation;
